import "./card.scss";
import {KeyboardEvent} from "react";

export default function CardRest() {

    const $wrapper = document.querySelector('.list-contents') as HTMLDivElement;

    if ($wrapper) {
        const $applyBtn = $wrapper.querySelector('.apply-btn') as HTMLElement;
        const $clearBtn = $wrapper.querySelector('.clear-btn') as HTMLElement;
        const $search = $wrapper.querySelector('.search') as HTMLElement;
        const $inputSearch = $search.querySelector('input') as HTMLInputElement;
        const $btnSearch = $search.querySelector('button') as HTMLButtonElement;
        const $noResults = $wrapper.querySelector('.no-results') as HTMLDivElement;
        const $body = $wrapper && $wrapper.querySelector('.view-content') as HTMLDivElement;
        const $pagination = $wrapper.querySelector('.pagination') as HTMLDivElement;
        const $paginationWrapper = $wrapper.querySelector('.pagination-wrapper') as HTMLElement;

        const itemsPerPage = 12;
        let currentPage = 1;

        init();

        function init() {
            const response = digestJson();
            create(response);
            apply(response);
            clear(response);
            search(response);

            if(response.length > itemsPerPage) {
                displayData(response, currentPage);
                setupPagination(response);
                updatePagination();
            } else {
                $pagination && $pagination.classList.add('d-none');
            }
        }

        function digestJson() {
            let rawArray = [];

            try {
                rawArray = JSON.parse(<string>(document.querySelector('#media-rest') as HTMLScriptElement).textContent);
            } catch (e) {
                rawArray = [];
                console.log('Unable to load JSON data');
            }

            return rawArray;
        }

        function create(data: any) {
            const $templateImage = $wrapper && $wrapper.querySelector('#template-image') as HTMLTemplateElement;
            const $templateVideo = $wrapper && $wrapper.querySelector('#template-video')as HTMLTemplateElement;
            const $templateRemoteVideo = $wrapper && $wrapper.querySelector('#template-remote-video')as HTMLTemplateElement;

            data.forEach((item: any) => {
                const bundle = item.bundle.toLowerCase().replace(/ /g,"_");

                switch (bundle) {
                    case 'remote_video' :
                        const $cloneRemoteVideo = $templateRemoteVideo && ($templateRemoteVideo.content.cloneNode(true)as HTMLElement);

                        if ($cloneRemoteVideo) {
                            const $iframe = $cloneRemoteVideo.querySelector('iframe')as HTMLElement;
                            let src: any;

                            if(item.field_media_oembed_video_1.includes('youtu.be')) {
                                src = item.field_media_oembed_video_1.replace('youtu.be', 'www.youtube.com/embed');
                            } else {
                                src = item.field_media_oembed_video_1;
                            }

                            $iframe.setAttribute('src', src);

                            const $image = $cloneRemoteVideo.querySelector('.image-cover')as HTMLElement;
                            if(item.field_media_image_2 != '') {
                                $image && ($image.innerHTML = item.field_media_image_2);
                            } else {
                                $image.remove();
                                const $playBtn = $cloneRemoteVideo.querySelector('.play-btn') as HTMLDivElement;
                                $playBtn.remove();
                            }

                            const $title = $cloneRemoteVideo.querySelector('.title')as HTMLElement;
                            $title && ($title.innerHTML = item.name);

                            const $date = $cloneRemoteVideo.querySelector('.date')as HTMLElement;
                            $date && ($date.innerHTML = item.created);

                            $body?.appendChild($cloneRemoteVideo);
                        }

                        break;

                    case 'video':
                        const $cloneVideo = $templateVideo && ($templateVideo.content.cloneNode(true)as HTMLElement);

                        if ($cloneVideo) {
                            const $video = $cloneVideo.querySelector('.video-card > video')as HTMLElement;

                            $video.setAttribute('src', item.field_media_video_file);

                            const stringImageSrc = item.field_media_image_2;
                            let regex = /<img.*?src=["'](.*?)["']/;

                            let match = stringImageSrc.match(regex);
                            if (match && match.length > 1) {
                                let src = match[1];
                                $video.setAttribute('poster', src);
                            }

                            const $image = $cloneVideo.querySelector('.image-cover')as HTMLElement;
                            $image && ($image.innerHTML = item.field_media_image_2);

                            const $title = $cloneVideo.querySelector('.title')as HTMLElement;
                            $title && ($title.innerHTML = item.name);

                            const $date = $cloneVideo.querySelector('.date')as HTMLElement;
                            $date && ($date.innerHTML = item.created);

                            $body?.appendChild($cloneVideo);
                        }

                        break;

                    case 'image':
                        const $cloneImage = $templateImage && ($templateImage.content.cloneNode(true) as HTMLElement);

                        if ($cloneImage) {
                            const $image = $cloneImage.querySelector('.image-container')as HTMLElement;
                            $image && ($image.innerHTML = item.field_media_image_2);

                            const $title = $cloneImage.querySelector('.title')as HTMLElement;
                            $title && ($title.innerHTML = item.name);

                            const $date = $cloneImage.querySelector('.date')as HTMLElement;
                            $date && ($date.innerHTML = item.created);

                            $body?.appendChild($cloneImage);
                        }

                        break;
                }
            })


            openImageModal();
            openVideoModal();
            handleVideoNoCover();
            handleVideoWithCover();
        }

        function applyValues(data: any) {
            const originalData = [...data];
            const $inputsChecked = $wrapper.querySelectorAll('input:checked');
            if($inputsChecked.length) {
                if($inputsChecked.length) {
                    let name: any;
                    const $cards = Array.from($wrapper.querySelectorAll('.rest'));
                    $cards.forEach(card => {
                        card?.parentElement?.parentElement?.classList.add('d-none');
                    })

                    const allFilteredMedia: any[] = [];
                    $inputsChecked.forEach((input: any) => {
                        const $inputsValue = input.getAttribute('value');
                        const filteredMedia = originalData.filter((item: any) => item.bundle.toLowerCase().replace(/ /g,"_").includes($inputsValue));

                        filteredMedia.forEach(el => {
                            name = el.name;
                            const find = $cards.filter(item => (item.querySelector('.title') as HTMLDivElement).innerHTML === name);

                            if(find) {
                                find.forEach((el: any) => {
                                    el?.parentElement?.parentElement?.classList.remove('d-none');
                                })
                            }
                        })

                        allFilteredMedia.push(...filteredMedia);
                        const sortedFilteredMedia = originalData.filter(item => allFilteredMedia.includes(item));

                        if(sortedFilteredMedia.length > itemsPerPage) {
                            if($pagination && $pagination.classList.contains('d-none')) {
                                $pagination.classList.remove('d-none')
                            }

                            $paginationWrapper.innerHTML = '';
                            let currentPage = 1;

                            displayData(sortedFilteredMedia, currentPage);
                            setupPagination(sortedFilteredMedia);
                            updatePagination();

                            const links = $wrapper.querySelectorAll('.page-link');
                            links.forEach(link => {
                                link.classList.remove('active');

                                const linkZero = $wrapper.querySelector('.page-link.index-0') as HTMLDivElement;
                                linkZero.classList.add('active');
                            })

                        } else {
                            $pagination && $pagination.classList.add('d-none')
                        }
                    });

                    openImageModal();
                    openVideoModal();
                    handleVideoNoCover();
                    handleVideoWithCover();
                }
            }
        }

        function apply(data: any) {
            $applyBtn.addEventListener('click', () => {
                $wrapper.classList.add('has-spinner');

                setTimeout(() => {
                    applyValues(data);
                    $wrapper.classList.remove('has-spinner');

                }, 500);
            })

            $applyBtn.addEventListener('keypress', (e) => {
                if(e.key === "Enter") {
                    $wrapper.classList.add('has-spinner');

                    setTimeout(() => {
                        applyValues(data);
                        $wrapper.classList.remove('has-spinner');

                    }, 500);
                }
            })
        }

        function clearValues(data: any) {
            const $cards = Array.from($wrapper.querySelectorAll('.rest'));
            $cards.forEach(card => {
                card?.parentElement?.parentElement?.classList.remove('d-none');
            })

            openImageModal();
            openVideoModal();
            handleVideoNoCover();
            handleVideoWithCover();

            if(data.length > itemsPerPage) {
                if($pagination && $pagination.classList.contains('d-none')) {
                    $pagination.classList.remove('d-none')
                }
                $paginationWrapper.innerHTML = '';
                let currentPage = 1;

                displayData(data, currentPage);
                setupPagination(data);
                updatePagination();

                const links = $wrapper.querySelectorAll('.page-link');
                links.forEach(link => {
                    link.classList.remove('active');

                    const linkZero = $wrapper.querySelector('.page-link.index-0') as HTMLDivElement;
                    linkZero.classList.add('active');
                })
            }
        }

        function clear(data: any) {
            $clearBtn.addEventListener('click', () => {
                $wrapper.classList.add('has-spinner');

                setTimeout(() => {
                    clearValues(data);
                    $wrapper.classList.remove('has-spinner');

                }, 500);
            })

            $clearBtn.addEventListener('keypress', (e) => {
                if(e.key === "Enter") {
                    $wrapper.classList.add('has-spinner');

                    setTimeout(() => {
                        clearValues(data);
                        $wrapper.classList.remove('has-spinner');

                    }, 500);
                }
            })
        }

        function setSearchValues(data: any) {
            const value = $inputSearch.value.toLowerCase();

            if(value !== '') {
                let name: any;
                const $cards = Array.from($wrapper.querySelectorAll('.rest'));
                $cards.forEach(card => {
                    card?.parentElement?.parentElement?.classList.add('d-none');
                })

                const searchedMedia = data.filter((item: any) => item.name.toLowerCase().includes(value));

                if(searchedMedia.length > 0) {
                    searchedMedia.forEach((el: any) => {
                        name = el.name;
                        const find = $cards.filter(item => (item.querySelector('.title') as HTMLDivElement).innerHTML === name);

                        if(find) {
                            find.forEach((el: any) => {
                                el?.parentElement?.parentElement?.classList.remove('d-none');
                            })
                        }
                    })

                    if(!$noResults.classList.contains('d-none')) {
                        $noResults.classList.add('d-none');
                    }

                    if(searchedMedia.length > itemsPerPage) {
                        let currentPage = 1;
                        if($pagination && $pagination.classList.contains('d-none')) {
                            $pagination.classList.remove('d-none')
                        }
                        $paginationWrapper.innerHTML = '';

                        displayData(searchedMedia, currentPage);
                        setupPagination(searchedMedia);
                        updatePagination();

                        const links = $wrapper.querySelectorAll('.page-link');
                        links.forEach(link => {
                            link.classList.remove('active');

                            const linkZero = $wrapper.querySelector('.page-link.index-0') as HTMLDivElement;
                            linkZero.classList.add('active');
                        })
                    } else {
                        $pagination && $pagination.classList.add('d-none');
                    }
                } else {
                    $noResults && $noResults.classList.remove('d-none');
                    $pagination && $pagination.classList.add('d-none')
                }
            } else {
                $noResults && $noResults.classList.add('d-none');
                const $cards = Array.from($wrapper.querySelectorAll('.rest'));
                $cards.forEach(card => {
                    card?.parentElement?.parentElement?.classList.remove('d-none');
                })

                if(data.length > itemsPerPage) {
                    let currentPage = 1;
                    if($pagination && $pagination.classList.contains('d-none')) {
                        $pagination.classList.remove('d-none')
                    }
                    $paginationWrapper.innerHTML = '';

                    displayData(data, currentPage);
                    setupPagination(data);
                    updatePagination();

                    const links = $wrapper.querySelectorAll('.page-link');
                    links.forEach(link => {
                        link.classList.remove('active');

                        const linkZero = $wrapper.querySelector('.page-link.index-0') as HTMLDivElement;
                        linkZero.classList.add('active');
                    })
                }
            }
        }

        function search(data: any) {
            $btnSearch.addEventListener('click', () => {
                $wrapper.classList.add('has-spinner');

                setTimeout(() => {
                    setSearchValues(data);
                    $wrapper.classList.remove('has-spinner');

                }, 500);

                openImageModal();
                openVideoModal();
                handleVideoNoCover();
                handleVideoWithCover();
            })

            $btnSearch.addEventListener('keypress', (e) => {
                if(e.key === "Enter") {
                    $wrapper.classList.add('has-spinner');

                    setTimeout(() => {
                        setSearchValues(data);
                        $wrapper.classList.remove('has-spinner');

                    }, 500);

                    openImageModal();
                    openVideoModal();
                    handleVideoNoCover();
                    handleVideoWithCover();
                }
            })

            $inputSearch.addEventListener('keypress', (e) => {
                if(e.key === "Enter") {
                    $wrapper.classList.add('has-spinner');

                    setTimeout(() => {
                        setSearchValues(data);
                        $wrapper.classList.remove('has-spinner');

                    }, 500);

                    openImageModal();
                    openVideoModal();
                    handleVideoNoCover();
                    handleVideoWithCover();
                }
            })
        }

        function openImageModal() {
            const $imageCardsFilters = $wrapper.querySelectorAll('.rest-media .image-card');

            if($imageCardsFilters.length) {
                const $modal = $wrapper.querySelector('.modal-img') as HTMLElement;
                const $modalImg = $modal.querySelector('img') as HTMLImageElement;
                const $modalTitle = $modal.querySelector('.title') as HTMLDivElement;
                const $maskMedia = $wrapper.querySelector('.mask.media') as HTMLElement;
                const $close = $maskMedia && $maskMedia.querySelector('.btn-close') as HTMLElement;

                $imageCardsFilters.forEach(($card: any) => {
                    $card.addEventListener('click', () => {
                        $modal.classList.remove('d-none');
                        $card.classList.add('full-screen');
                        const $cardFull = $body.querySelector('.image-card.full-screen') as HTMLElement;
                        const cardSrc = ($cardFull && $cardFull.querySelector('img') as HTMLElement).getAttribute('src') as any;
                        $modalImg.setAttribute('src', cardSrc);
                        $maskMedia.classList.remove('d-none');
                        document.body.style.overflow = 'hidden';
                        $modalTitle.innerText = ($cardFull.querySelector('.title') as HTMLDivElement).innerText;
                    })

                    $card.addEventListener('keypress', (e: KeyboardEvent) => {
                        if (e.code === 'Enter') {
                            $modal.classList.remove('d-none');
                            $card.classList.add('full-screen');
                            const $cardFull = $body.querySelector('.image-card.full-screen') as HTMLElement;
                            const cardSrc = ($cardFull && $cardFull.querySelector('img') as HTMLElement).getAttribute('src') as any;
                            $modalImg.setAttribute('src', cardSrc);
                            $maskMedia.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';
                            $modalTitle.innerText = ($cardFull.querySelector('.title') as HTMLDivElement).innerText;
                            $close.focus();
                        }
                    })

                    $maskMedia.addEventListener('click', () => {
                        $modal.classList.add('d-none');
                        $maskMedia.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                        $card.classList.remove('full-screen');
                    })

                    $close.addEventListener('click', () => {
                        $modal.classList.add('d-none');
                        $maskMedia.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                        $card.classList.remove('full-screen');
                    })

                    $close.addEventListener('keypress', (e) => {
                        if (e.code === 'Enter') {
                            $modal.classList.add('d-none');
                            $maskMedia.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $card.classList.remove('full-screen');
                            $card.focus();
                        }
                    })
                })
            }
        }

        function handleVideoNoCover() {
            const $videoNoCover = $wrapper.querySelectorAll('.rest-media .no-cover');
            if($videoNoCover.length) {
                $videoNoCover.forEach($el => {
                    const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                    const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                    const $infoWrapper = $ytVideo?.parentElement?.querySelector('.info-wrapper') as HTMLElement;
                    const $titleWrapper = $ytVideo?.parentElement?.querySelector('.title-wrapper') as HTMLElement;

                    window.addEventListener('load', () => {
                        $el.addEventListener('click', () => {
                            $infoWrapper.classList.add('d-none');
                            $titleWrapper.classList.add('d-none');
                            $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                            $videoCover && $videoCover.classList.add('d-none');
                        })
                    })
                });
            }
        }

        function handleVideoWithCover() {
            const $videoWithCover = $wrapper.querySelectorAll('.rest-media .video-card.youtube-video:not(.video-card.youtube-video.no-cover)');
            $videoWithCover.forEach($el => {
                const $playBtn = $el.querySelector('.play-btn') as HTMLDivElement;
                const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                const $infoWrapper = $ytVideo?.parentElement?.querySelector('.info-wrapper') as HTMLElement;
                const $titleWrapper = $ytVideo?.parentElement?.querySelector('.title-wrapper') as HTMLElement;

                window.addEventListener('load', () => {
                    $el.addEventListener('click', () => {
                        $videoCover && $videoCover.classList.add('d-none');
                        $playBtn && $playBtn.classList.add('d-none');
                        $infoWrapper.classList.add('d-none');
                        $titleWrapper.classList.add('d-none');
                        $ytVideo.setAttribute('src', $ytVideo.src + '&autoplay=1');
                    })
                })
            });
        }

        function openVideoModal() {
            const $videoCardsFilter = $wrapper.querySelectorAll('.rest-media .video-card.rest');
            if ($videoCardsFilter.length) {
                $videoCardsFilter.forEach(($el: any) => {
                    const $maskMedia = $wrapper.querySelector('.mask.media') as HTMLElement;
                    const $close = $maskMedia && $maskMedia.querySelector('.btn-close') as HTMLElement;
                    const $video = $el.querySelector('video') as HTMLVideoElement;
                    const $playBtn = $el.querySelector('.play-btn') as HTMLDivElement;
                    const $ytVideo = $el.querySelector('.yt-video') as HTMLIFrameElement;
                    const $modal = $wrapper.querySelector('.modal-video') as HTMLElement;
                    const $modalVideo = $modal.querySelector('video') as HTMLVideoElement;
                    const $modalTitle = $modal.querySelector('.title') as HTMLDivElement;

                    if ($ytVideo) {
                        $el.classList.add('youtube-video');
                        $ytVideo.setAttribute('src', $ytVideo.src + '?enablejsapi=1');
                        const $videoCover = $el.querySelector('.video-yt-cover') as HTMLElement;
                        const $imageCover = $videoCover.querySelector('.image-cover') as HTMLElement;

                        if(!$imageCover) {
                            $el.classList.add('no-cover');
                        }
                    }


                    if ($video) {
                        $modalVideo.controls = false;
                        $video.controls = false;
                        $playBtn.addEventListener('click', () => {
                            $video.parentElement?.classList.add('full-screen');
                            $modal.classList.remove('d-none');
                            const $videoFull = $body.querySelector('.video-card.full-screen') as HTMLElement;
                            const videoSrc = ($videoFull.querySelector('video') as HTMLElement).getAttribute('src') as any;
                            $modalVideo.setAttribute('src', videoSrc);
                            $modalVideo.play();
                            $playBtn.classList.add('d-none');
                            $modalVideo.controls = true;
                            $maskMedia.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';
                            $modalTitle.innerText = ($videoFull.querySelector('.title') as HTMLDivElement).innerText;
                        })

                        $modalVideo.addEventListener('ended', () => {
                            $playBtn.classList.remove('d-none');
                            $modal.classList.add('d-none');
                            $maskMedia.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $video.parentElement?.classList.remove('full-screen');
                            $modalVideo.controls = false;
                            $modalVideo.load();
                            $video.controls = false;
                        })

                        $playBtn.addEventListener('keypress', function (e) {
                            if (e.code === 'Enter') {
                                $video.parentElement?.classList.add('full-screen');
                                $modal.classList.remove('d-none');
                                const $videoFull = $body.querySelector('.video-card.full-screen') as HTMLElement;
                                const videoSrc = ($videoFull.querySelector('video') as HTMLElement).getAttribute('src') as any;
                                $modalVideo.setAttribute('src', videoSrc);
                                $modalVideo.play();
                                $playBtn.classList.add('d-none');
                                $modalVideo.controls = true;
                                $maskMedia.classList.remove('d-none');
                                document.body.style.overflow = 'hidden';
                                $modalTitle.innerText = ($videoFull.querySelector('.title') as HTMLDivElement).innerText;
                                $close.focus();
                            }
                        })

                        $maskMedia.addEventListener('click', () => {
                            $playBtn.classList.remove('d-none');
                            $modal.classList.add('d-none');
                            $maskMedia.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $video.parentElement?.classList.remove('full-screen');
                            $modalVideo.controls = false;
                            $modalVideo.load();
                            $video.controls = false;
                        })

                        $close.addEventListener('click', () => {
                            $playBtn.classList.remove('d-none');
                            $modal.classList.add('d-none');
                            $maskMedia.classList.add('d-none');
                            document.body.style.overflow = 'scroll';
                            $video.parentElement?.classList.remove('full-screen');
                            $modalVideo.controls = false;
                            $modalVideo.load();
                            $video.controls = false;
                        })

                        $close.addEventListener('keypress', (e) => {
                            if (e.code === 'Enter') {
                                $playBtn.classList.remove('d-none');
                                $modal.classList.add('d-none');
                                $maskMedia.classList.add('d-none');
                                document.body.style.overflow = 'scroll';
                                $video.parentElement?.classList.remove('full-screen');
                                $modalVideo.controls = false;
                                $modalVideo.load();
                                $video.controls = false;
                                $el.focus();
                            }
                        })

                        window.addEventListener('load', () => {
                            const $videoDuration = $el.querySelector('.time') as HTMLElement;

                            if($videoDuration) {
                                $videoDuration.innerHTML = secondsConvert($video.duration);
                            }
                        })
                    }
                })
            }
        }

        function secondsConvert(secondsDuration: any) {
            let m = Math.floor(secondsDuration / 60);
            secondsDuration = Math.floor(secondsDuration % 60);
            secondsDuration = (secondsDuration >= 10) ? secondsDuration : "0" + secondsDuration;
            return m + ":" + secondsDuration;
        }

        function displayData(data: any, page: any) {
            const start = (page - 1) * itemsPerPage;
            let end = start + itemsPerPage;
            const pageData = data.slice(start, end);

            if (end > data.length) {
                end = data.length;
            }

            const $paginationLabel = $wrapper.querySelector('.rest-media .pagination-label span') as HTMLElement;
            const $label = $wrapper.querySelector('.rest-media .label') as HTMLElement;
            let name: any;

            const $cards = Array.from($wrapper.querySelectorAll('.rest'));
            $cards.forEach(card => {
                card?.parentElement?.parentElement?.classList.add('d-none');
            })

            pageData.forEach((el: any) => {
                name = el.name;
                const find = $cards.filter(item => (item.querySelector('.title') as HTMLDivElement).innerHTML === name);

                if(find) {
                    find.forEach((el: any) => {
                        el?.parentElement?.parentElement?.classList.remove('d-none');
                    })
                }
            })

            $label.innerHTML = $paginationLabel.innerText
                .replace("{numeroPrimoElementoInPagina}", `<b>${start + 1}</b>`)
                .replace("{numeroUltimoElementoInPagina}", `<b>${end}</b>`)
                .replace("{numeroTotaleElementi}", data.length)

            openVideoModal();
            openImageModal();
            handleVideoNoCover();
            handleVideoWithCover();
        }

        function setupPagination(data: any) {
            const totalPages = Math.ceil(data.length / itemsPerPage);
            const $paginationWrapper = $wrapper.querySelector('.pagination-wrapper') as HTMLElement;

            Array.from({ length: totalPages }).forEach((_item, i) => {
                const li = document.createElement('li');
                const link = document.createElement('div');

                link.classList.add('page-link', `index-${i}`);
                link.textContent = String(i + 1);
                if (i + 1 === currentPage) {
                    link.classList.add('active');
                }

                link.addEventListener('click', () => {
                    currentPage = i + 1;
                    displayData(data, currentPage);
                    updatePagination();

                    const $leftArrow = $wrapper.querySelector('.left-arrow') as HTMLDivElement;
                    const $rightArrow = $wrapper.querySelector('.right-arrow') as HTMLDivElement;

                    if (currentPage !== 1 && !$leftArrow) {
                        const leftArrow = document.createElement('li');
                        leftArrow.classList.add('left-arrow');
                        const leftArrowLink = document.createElement('div');
                        leftArrowLink.classList.add('left-arrow-link');
                        leftArrow.appendChild(leftArrowLink);
                        leftArrow.addEventListener('click', () => {
                            currentPage--;
                            displayData(data, currentPage);
                            updatePagination();

                            if (currentPage === 1) {
                                const $leftArrow = $wrapper.querySelector('.left-arrow') as HTMLDivElement;
                                $leftArrow.remove();
                            }
                        });
                        $paginationWrapper.appendChild(leftArrow);
                        const firstPageLink = $paginationWrapper.querySelector('.page-link.index-0') as HTMLElement;
                        $paginationWrapper.insertBefore(leftArrow, firstPageLink?.parentElement);

                    } else if (currentPage === 1) {
                        $leftArrow.remove();
                    }

                    if (currentPage !== totalPages && !$rightArrow) {
                        const rightArrow = document.createElement('li');
                        rightArrow.classList.add('right-arrow');
                        const rightArrowLink = document.createElement('div');
                        rightArrowLink.classList.add('right-arrow-link');
                        rightArrow.appendChild(rightArrowLink);
                        rightArrow.addEventListener('click', () => {
                            currentPage++;
                            displayData(data, currentPage);
                            updatePagination();

                            if (currentPage === totalPages) {
                                const $rightArrow = $wrapper.querySelector('.right-arrow') as HTMLDivElement;
                                $rightArrow.remove();
                            }
                        });
                        $paginationWrapper.appendChild(rightArrow);
                    } else if (currentPage === totalPages) {
                        $rightArrow.remove();
                    }
                });

                li.appendChild(link);

                $paginationWrapper.appendChild(li);
            });

            if (currentPage !== totalPages) {
                const rightArrow = document.createElement('li');
                rightArrow.classList.add('right-arrow');
                const rightArrowLink = document.createElement('div');
                rightArrowLink.classList.add('right-arrow-link');
                rightArrow.appendChild(rightArrowLink);
                rightArrow.addEventListener('click', () => {
                    currentPage++;
                    displayData(data, currentPage);
                    updatePagination();
                });
                $paginationWrapper.appendChild(rightArrow);
            }
        }

        function updatePagination() {
            const paginationLinks = document.querySelectorAll('.page-link');

            paginationLinks.forEach((link, index) => {
                if (index + 1 === currentPage) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            });
        }
    }
}